export const HELIUM10_WORLD_D0MAIN = "helium10.com";
export const HELIUM10_CHINA_D0MAIN = "h10.com.cn";
export const isDevHost = () => !(process.env.REACT_APP_WITH_PROXY === "true") &&
    (window.location.hostname.includes("helium10-dev.com") ||
        window.location.hostname.includes("helium-dev.com") ||
        (!(window.location.host.includes("adtomic.stg") ||
            window.location.host.includes("native-re-adtomic-stg")) &&
            window.location.host.includes(".stg.helium10.com")) ||
        window.location.host === "h10mail.com");
export const isChina = window.location.hostname.includes(HELIUM10_CHINA_D0MAIN);
export const transformHelium10Domain = (url) => isChina ? url.replace(HELIUM10_WORLD_D0MAIN, HELIUM10_CHINA_D0MAIN) : url;
// The backend developers of the main app have their own members service, so the frontend application should automatically send member requests there
export const isMainAppDevOrCi = !(process.env.REACT_APP_WITH_PROXY === "true") &&
    (window.location.hostname.includes("helium-dev.com") ||
        window.location.hostname.includes("ci.helium10-dev.com"));
export const membersLink = transformHelium10Domain(isMainAppDevOrCi ? window.location.origin : process.env.REACT_APP_MEMBERS_DOMAIN || "");
export const tokenLink = "/api/v1/site/token";
export const signinLink = "/user/signin";
